/*
 * Chakra theme defaults
 *
 * This file should contain base styles that apply to ALL meetings
 * Essentially the default theme for all meetings
 */

import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react"

import fonts from "./fonts"
import breakpoints from "./breakpoints"
import textStyles from "./textStyles"
import globalCss from "./globalsCss"
import fontSizes from "./fontSizes"
import recipes from "./recipes"
import slotRecipes from "./slotRecipes"

export default function makeTheme(siteTheme) {
    const colors = {
        color1: { value: siteTheme.colorPalette[0].color1 },
        color2: { value: siteTheme.colorPalette[0].color2 },
        color3: { value: siteTheme.colorPalette[0].color3 },
        color4: { value: siteTheme.colorPalette[0].color4 },
        color5: { value: siteTheme.colorPalette[0].color5 },
        color6: { value: siteTheme.colorPalette[0].color6 },
        color7: { value: siteTheme.colorPalette[0].color7 },
        color8: { value: siteTheme.colorPalette[0].color8 },
        color9: { value: siteTheme.colorPalette[0].color9 },
        color10: { value: siteTheme.colorPalette[0].color10 },
        color11: { value: siteTheme.colorPalette[0].color11 },
        color12: { value: siteTheme.colorPalette[0].color12 },
        color13: { value: siteTheme.colorPalette[0].color13 },
        color14: { value: siteTheme.colorPalette[0].color14 },
        color15: { value: siteTheme.colorPalette[0].color15 },
        color16: { value: siteTheme.colorPalette[0].color16 },
        tctmdred: { value: "#ac0034" }, // var(--chakra-colors-tctmdred)
        red: {
            DEFAULT: { value: "#ea002a" },
        },
        yellow: { value: "#F3BD00" },
        error: { value: "#C53030" },
        // Override default gray palette with subtle cool gray
        gray: {
            50: { value: "#f8fafc" },
            100: { value: "#f1f5f9" },
            200: { value: "#e2e8f0" },
            300: { value: "#cbd5e1" },
            400: { value: "#94a3b8" },
            500: { value: "#64748b" },
            600: { value: "#475569" },
            700: { value: "#334155" },
            800: { value: "#1e293b" },
            900: { value: "#0f172a" },
            950: { value: "#020617" },
        },
    }

    const config = defineConfig({
        disableLayers: false,
        preflight: true,
        globalCss: globalCss,
        theme: {
            breakpoints,
            recipes: recipes,
            slotRecipes: slotRecipes,
            textStyles,
            tokens: {
                config: {
                    initialColorMode: "light",
                    useSystemColorMode: false,
                },
                fonts,
                fontSizes,
                colors,
                sizes: {
                    largeSizes: {
                        sm: { value: "640px" },
                        md: { value: "768px" },
                        lg: { value: "1024px" },
                        xl: { value: "1280px" },
                    },
                    header: {
                        h: { value: "62px" },
                    },
                },
            },
            // original
            // header: {
            //     h: { base: "44px", md: "62px" },
            // },
            // backgroundImage: siteTheme.backgroundImage,
        },
    })

    return createSystem(defaultConfig, config)
}
